<template>
  <Modal
    v-model="config"
    :title="type == 0 ? '微信支付' : '支付宝支付'"
    footer-hide
    @on-cancel="cancel"
  >
<!--    <div class="modal-content">-->
<!--      <div ref="qrCodeDiv" class="code-area"></div>-->
<!--    </div>-->
<!--    <div class="tips">-->
<!--      {{-->
<!--        type == 1-->
<!--          ? "请使用微信扫一扫，扫描二维码支付"-->
<!--          : "请使用支付宝扫一扫，扫描二维码支付"-->
<!--      }}-->
<!--    </div>-->
    <div class="content">
      <iframe :srcdoc="codeUrl"
              frameborder="no"
              border="0"
              marginwidth="0"
              marginheight="0"
              scrolling="no"
              width="200"
              height="200"
              style="overflow:hidden;">
      </iframe>
    </div>
    <div class="foot">
      <Button @click="cancel">选择其他支付方式</Button>
    </div>
  </Modal>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      // 1 微信支付，2 支付宝支付
      type: [Number, String],
      default: 1,
    },
    codeUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      code: null,
    };
  },
  computed: {
    config: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  watch: {
    codeUrl: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.$nextTick(function () {
          });
        }
      },
    },
  },
  methods: {
    cancel() {
      this.config = false;
    },
    /**
     * @description 生成付款二维码
     */
    bindQRCode(codeUrl) {
      if (this.code) {
        this.$refs.qrCodeDiv.innerHTML = "";
        this.code.clear();
      }
      this.code = new QRCode(this.$refs.qrCodeDiv, {
        text: codeUrl,
        width: 160,
        height: 160,
        colorDark: "#333333", // 二维码颜色
        colorLight: "#ffffff", // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modal-content {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.code-area {
  width: 160px;
  height: 160px;
}
.tips {
  margin-top: 10px;
  color: #2d8cf0;
  text-align: center;
}
.content {
  height: auto;
  min-height: 220px;
  max-height: 500px;
  overflow: auto;
  text-align: center;
}
.foot {
  text-align: center;
}
</style>
